import React, { useContext, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { AppContext } from '../../App';

const Home = (props) => {
  const [user, setUser] = useState(false)
  const [courses, setCourses] = useState([]);
  const [myApplications, setMyApplications] = useState([]);
  const appContext = useContext(AppContext);

  useEffect(() => {

    appContext.httpClient.get({
      path: "user"
    }).then(response => {
      if (response.result) {
        console.log(response.result)
        setUser(response.result);
      }
    })

    appContext.httpClient.get({
      path: "course/published"
    }).then(response => {
        if (response.success && response.result) {
          console.log(response)
          setCourses(response.result);
        } 
    });
    
    appContext.httpClient.get({
      path: "courseapplication/myapplications"
    }).then(response => {
        if (response.result) {             
          setMyApplications(response.result);
          console.log(response.result)
        }
    });
  }, [appContext.apiBaseUrl]);

  const today = new Date();

  const formatDate = (dateString) => {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  const daysUntilCourseStarts = (startDate) => {
    const today = new Date();
    const start = new Date(startDate);
    const differenceInTime = start - today;
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24)); // Convert milliseconds to days
    return differenceInDays;
  };

  return (
    <div>
      {/* Hero */}
      <section className="hero hero--education relative h-80 bg-gradient-to-r from-darkHero to-lightHero text-white">
        <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <header className="section-header mt-auto mb-10">
            <h2 className="section-title text-4.5xl font-bold">Education</h2>
          </header>
          {/* Breadcrumbs */}
          <div className="breadcrumbs mb-4">
            <ul className="flex">
              <li><a className="white underline" href="/">Home</a></li>
              <li className="breadcrumb-current">
                <span className="breadcrumb-seperator mx-1">\</span><span className="text-fontColor">Education</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex absolute top-0 left-0 right-0 bottom-0">
          <img className="object-cover lg:object-contain lg:object-right ml-auto" src="https://insol.azureedge.net/cmsstorage/insol/media/heros/hero-arrow-education.png" alt="" />
        </div>
      </section>

      <section className="py-8 lg:py-12">
        <header className="section__header">
          <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem px-4">
            <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Welcome to the Education pages of the INSOL International website</h1>
          </div>
        </header>
        <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <span className="border border-brandMidBlue bg-brandGrey p-10 text-brandMidBlue mb-4" style={{ display: 'block' }}>
        Please note that we are in the process of implementing a new Education System which will operate directly from these Education web pages. During this period of implementation some courses will be accessed from the old, existing Education System and some will be accessed from the new Education System. Please read the information below relating to the various options.
            </span>
         <p className="text-brandMidBlue mb-4">If you are enrolled on one the following courses, you should please click on the tile below stating “My existing courses” and proceed as you normally would in accessing your course, please note you will need to be signed in to your account in order to see this tile:</p>
         <ul className="text-brandMidBlue ml-4 mb-4 list-disc">
          <li>Foundation Certificate 2023/24</li>
          <li>Foundation Certificate 2024/25</li>
          <li>Programme in South African Insolvency Law and Practice 2024</li>
          <li>Programme in South African Business Rescue 2024</li>
          <li>Introductory Certificate in Insolvency Law and Practice in the Cayman Islands 2024</li>
        </ul>
        <p className="text-brandMidBlue mb-4">If you are enrolled on the <strong>Global Insolvency Practice Course 2024/25 (GIPC)</strong>, you will notice that you have been (or are in the process of being) migrated across to the new Education System. If you have been migrated across you will see the GIPC course tile under “My courses” and your status on the course will show that you are enrolled (the remaining number of days left on the course will show on the tile). Clicking on this tile will take you into the GIPC course content. Alternatively, you will still be able to access the course on the old Education System by clicking on the “My existing courses” tile and following the process you used to follow to access the course and the course material.</p>
        <p className="text-brandMidBlue mb-4">If you are looking to enrol on the following courses, please click on the appropriate course tile below under “All courses” which will take you to where you need to be:</p>
        <ul className="text-brandMidBlue ml-4 mb-4 list-disc">
          <li>Programme in South African Insolvency Law and Practice 2025</li>
          <li>Programme in South African Business Rescue 2025</li>
          <li>Introductory Certificate in Insolvency Law and Practice in the Cayman Islands 2025</li>
        </ul>
        <p className="text-brandMidBlue mb-4">Once you have clicked on the relevant course tab, you will find a course overview and a downloadable Course Brochure. In order to apply, click on the red “Apply now” button which will take you straight into the online application form. Please note that we only accept applications made online.</p>
        <p className="text-brandMidBlue">If you encounter any difficulties accessing the course(s) on which you are currently enrolled, or wish to enquire about the process for enrolling on any new courses, please contact David Burdette (<a className="underline" href="mailto:david.burdette@insol.org">david.burdette@insol.org</a>) or Brenda Bennett (<a className="underline" href="mailto:brenda.bennett@insol.org">brenda.bennett@insol.org</a>).</p>
        </div>
      </section>

      {/* My Courses */}
      <section className="courses py-8 lg:py-12">
        <header className="section__header">
          <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem px-4">
            <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">My courses</h1>
            {/*<div className="section__header-row mb-6 max-w-640">
              <span className="section__header-subtitle text-brandMidBlue">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</span>
            </div>*/}
          </div>
        </header>
        <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            
            {user && (
            <article className="relative p-6 text-white bg-gradient-to-b from-brandDarkBlue to-brandMidBlue">
              <div className="course__desc">
                <h3 className="course__title text-xl mb-4">My existing courses</h3>
                <span className="course__summary">Please click here to access your existing courses you are registered on.</span>
              </div>
              <a href="/education/portal" className="absolute top-0 right-0 bottom-0 left-0 text-0">Read more</a>
            </article>
            )}

            {myApplications.map((course, index) => (
              <article key={index} className="relative p-6 text-white bg-gradient-to-b from-brandDarkBlue to-brandMidBlue">
                {course.status !== "Enrolled" && (<span className="absolute bg-brandRed -top-5 right-6 py-2 px-3"><strong>Application Status: </strong>{course.status}</span>)}
                <div className={`course__desc ${course.status === "Enrolled" ? "pb-6 mb-4 border-b" : ""}`}>
                  <h3 className="course__title text-xl mb-4">{course.courseTitle}</h3>
                  <span className="course__summary">{course.courseSummary}</span>
                </div>
                <div className="course__info">
                  {course.status === "Enrolled" && new Date(course.courseStartDate) > today && (
                  <div className="flex items-center mb-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-clock" viewBox="0 0 16 16">
                        <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                      </svg>
                      <span>{`Course Starts in ${daysUntilCourseStarts(course.courseStartDate)} Days`}</span>
                  </div>
                  )}
                  {course.status === "Enrolled" && new Date(course.courseStartDate) < today && new Date(course.courseEndDate) > today && (
                  <div className="flex items-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-clock-fill" viewBox="0 0 16 16">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                    </svg>
                    <span>{`Course Ends in ${daysUntilCourseStarts(course.courseEndDate)} Days`}</span>
                  </div>
                  )}
                  {/*
                  <div className="flex items-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-bookmark-plus" viewBox="0 0 16 16">
                      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z" />
                      <path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4" />
                    </svg>
                    <span>Assessments not yet submitted</span>
                  </div>
                  <div className="flex items-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-bookmark-dash" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M5.5 6.5A.5.5 0 0 1 6 6h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5" />
                      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z" />
                    </svg>
                    <span>Assessments being marked</span>
                  </div>
                  <div className="flex items-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-bookmark-star-fill" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5M8.16 4.1a.178.178 0 0 0-.32 0l-.634 1.285a.18.18 0 0 1-.134.098l-1.42.206a.178.178 0 0 0-.098.303L6.58 6.993c.042.041.061.1.051.158L6.39 8.565a.178.178 0 0 0 .258.187l1.27-.668a.18.18 0 0 1 .165 0l1.27.668a.178.178 0 0 0 .257-.187L9.368 7.15a.18.18 0 0 1 .05-.158l1.028-1.001a.178.178 0 0 0-.098-.303l-1.42-.206a.18.18 0 0 1-.134-.098z" />
                    </svg>
                    <span>Congratulations you've passed</span>
                  </div>
                  */}
                </div>
                <Link to={`../course/${course.courseId}`} className="absolute top-0 right-0 bottom-0 left-0 text-0">Read more</Link>
              </article>
            ))}

              {/*
              <article className="relative p-6 text-white bg-gradient-to-b from-brandDarkBlue to-brandMidBlue">
                <span className="absolute bg-brandRed -top-5 right-6 py-2 px-3"><strong>Application Status: </strong>Pending</span>
                <div className="course__desc pb-6 mb-4 border-b">
                  <h1 className="course__title text-xl mb-4">The Foundation Certficate</h1>
                  <span className="course__summary">A postgraduate certificate programme aimed at inexperienced or new entrants to the insolvency profession.</span>
                </div>
                <div className="course__info">
                  <div className="flex items-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-clock" viewBox="0 0 16 16">
                      <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                    </svg>
                    <span>Course Starts in XX Days</span>
                  </div>
                  <div className="flex items-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-clock-fill" viewBox="0 0 16 16">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                    </svg>
                    <span>Course Ends in XX Days</span>
                  </div>
                  <div className="flex items-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-bookmark-plus" viewBox="0 0 16 16">
                      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z" />
                      <path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4" />
                    </svg>
                    <span>Assessments not yet submitted</span>
                  </div>
                  <div className="flex items-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-bookmark-dash" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M5.5 6.5A.5.5 0 0 1 6 6h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5" />
                      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z" />
                    </svg>
                    <span>Assessments being marked</span>
                  </div>
                  <div className="flex items-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-bookmark-star-fill" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5M8.16 4.1a.178.178 0 0 0-.32 0l-.634 1.285a.18.18 0 0 1-.134.098l-1.42.206a.178.178 0 0 0-.098.303L6.58 6.993c.042.041.061.1.051.158L6.39 8.565a.178.178 0 0 0 .258.187l1.27-.668a.18.18 0 0 1 .165 0l1.27.668a.178.178 0 0 0 .257-.187L9.368 7.15a.18.18 0 0 1 .05-.158l1.028-1.001a.178.178 0 0 0-.098-.303l-1.42-.206a.18.18 0 0 1-.134-.098z" />
                    </svg>
                    <span>Congratulations you've passed</span>
                  </div>
                </div>
                <Link to="course" className="absolute top-0 right-0 bottom-0 left-0 text-0">Read more</Link>
              </article>
              */}
          </div>

          {!user && (
            <span className="border border-brandMidBlue bg-brandGrey p-10 text-brandMidBlue mt-10" style={{ display: 'block' }}>
              Please login to view and access your courses.
            </span>
          )}

          {/* If not applied to any courses */}
          {!myApplications && (
            <span className="border border-brandMidBlue bg-brandGrey p-10 text-brandMidBlue mt-10" style={{ display: 'block' }}>
              You are not enrolled on any courses. Please apply to a course below to get started.
            </span>
          )}
          {/* If not applied to any courses */}
        
        </div>
      </section>

      {/* All Courses */}
      <section className="courses py-8 lg:py-12 bg-brandGrey">
        <header className="section__header">
          <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem px-4">
            <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">All courses</h1>
            {/*<div className="section__header-row mb-6 max-w-640">
              <span className="section__header-subtitle text-brandMidBlue">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</span>
            </div>*/}
          </div>
        </header>
        <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">

              {courses.map((course, index) => (
              <article key={course.courseId} className="relative p-6 text-white bg-gradient-to-b from-brandDarkBlue to-brandMidBlue">
                <div className="course__desc">
                  <h3 className="course__title text-xl mb-4">{course.courseTitle}</h3>
                  <span className="course__summary">{course.courseSummary}</span>
                </div>
                <Link to={`../course/${course.courseId}`} className="absolute top-0 right-0 bottom-0 left-0 text-0">Read more</Link>
              </article>
              ))}

          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;